<template>
    <div class="lang">
        <div class="info">
            <h3 class="bullet01">住院(日程安排) 流程</h3>
            <ul class="step-box">
                <li class="step-box__item"><span class="step-box__item--step">步骤 1</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">住院评估及住院时间安排</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">步骤 02</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">发送短信, 通知您住院时间和可用病房等级 (住院当天)</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">步骤 03</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">手续办理流程和住院</h4>
                    </div>
                </li>
            </ul>
            <h4 class="depth bullet02 mt20">确定住院与预约住院</h4>
            <p class="depth">如果在科室或急诊治疗时确定患者需要住院治疗, 负责/主治医生将在系统中输入住院日期.</p>
            <p class="depth">患者及其监护人将于住院当日办理住院手续, 并在行政办公室的住院/出院 (急诊室) 柜台预约.</p>
            <h4 class="depth bullet02">发送住院手续短信(住院当日)</h4>
            <p class="depth">住院当天安排到病房后, 以Kakaotalk信息或短信方式通知住院时间与可用病房等级. 将按照实际情况 (病房情况与出院患者的情况) 安排病房.</p>
            <p class="depth">因此, 您在住院当天实际安排到的病房等级有可能与您的要求略有差别.</p>
            <h4 class="depth bullet02">住院手续及病房入室</h4>
            <p class="depth">住院当天收到住院通知的患者请与陪护人一同到行政窗口填写住院协议书(上级病房申请书，连带担保人).</p>
            <div class="table mt20">
                <table>
                    <colgroup>
                        <col style="width: calc(100% / 3)">
                        <col style="width: calc(100% / 3)">
                        <col style="width: calc(100% / 3)">
                    </colgroup>
                    <thead>
                        <tr>
                            <th colspan="3">住院准备用品</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="left">
                                个人用品，包括洗漱用品, 毛巾, 杯子, 室内鞋, 卫生纸等, 以及陪护人用的被褥
                            </td>
                            <td class="left">
                                <p>住院前服用的药物 (自带药品)</p>
                                <p class="bullet03">
                                    住院前若有服用过的药物时，请携带其药物和处方. <br>
                                    对自带的药品服用与否由主治医生判断下进行，患者不可以擅自服用.
                                </p>
                                <p class="bullet03">
                                    若有需要, 可以用住院处方代替其携带的药物.
                                </p>
                            </td>
                            <td class="left">
                                为了防止感染, 火灾和安全事故, 限制使用加湿器, 电咖啡壶, 风扇, 以及电热毯等电加热器和易燃/可燃材料.
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <p class="mt10 font-sub">
                ※ 住/出院时，凡需要出具诊断书及医务记录，证明材料时，请携带身份证. <br>
                但，未满14周岁的未成年人需提供监护人身份证件以及直系亲属关系的证明文件(副本，家庭关系证明).
            </p>
        </div>
        <div class="info">
            <h3 class="bullet01">出院流程</h3>
            <ul class="step-box">
                <li class="step-box__item"><span class="step-box__item--step">步骤 01</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">出院评估</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">步骤 02</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">出院时提醒</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">步骤 03</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">保险筛查</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">步骤 04</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">付款</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">步骤 05</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">取药</h4>
                    </div>
                </li>
            </ul>
            <h4 class="depth bullet02 mt20">出院评估</h4>
            <p class="depth ">将由负责/主治医生在出院当天或前一天作出最终出院决定.</p>
            <h4 class="depth bullet02 mt20">出院时提醒</h4>
            <p class="depth ">您的护士会提醒您要遵循的时间表, 包括门诊/住院和门诊检查的时间, 并整理病历.</p>
            <h4 class="depth bullet02 mt20">保险筛查</h4>
            <p class="depth ">保险筛查和病历机构落实后, 审查小组将对您的处方进行保险审查.</p>
            <h4 class="depth bullet02 mt20">付款</h4>
            <p class="depth ">保险审查小组完成付款审查后, 将向患者或监护人发送短信. 然后患者可在行政办公室的住院/出院柜台或病房的结账付款台付款 (住院/出院).</p>
            <h4 class="depth bullet02 mt20">取药</h4>
            <p class="depth ">付款完成之后, 护士会在患者回家之前说明一些注意事项, 包括药物治疗方案.</p>
        </div>
        <div class="info">
            <h3 class="bullet01">支付中间医疗费用</h3>
            <h4 class="depth bullet02">查看和支付中间医疗费用</h4>
            <p class="depth">
                审查和支付中间医疗费用可在行政办公室的住院/出院柜台或病房的结账付款台进行. 该数额表明截至前一天已输入系统的内容(尚待审查)；因此, 它可能不同于在出院时需要支付的实际数额.
            </p>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>